import styled from 'styled-components'

export const MainWrapper = styled.div`
  margin: 0 40px;
  height: calc(100vh - 124px);
`
